import React from "react";
import Header from "../../Layouts/Header";
import "./index.css"; // Your styles
import "../../CommonContainer/common.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import bannerSubimg from "../../../Assets/images/furniture-img.png";


import img1 from "../../../Assets/images/furniture/furnitureimg1.png"

import necklace1 from "../../../Assets/images/Jewellery/necklace1.jpg";
import necklace2 from "../../../Assets/images/Jewellery/necklace1.jpg";
import necklace3 from "../../../Assets/images/Jewellery/necklace1.jpg";

import f1img1 from "../../../Assets/images/furniture/f1-image.png"   
import f2img2 from "../../../Assets/images/furniture/f2-image.png"
import f3img3 from "../../../Assets/images/furniture/f3-image.png"

import furnitureimg1 from "../../../Assets/images/f-1.png"

import furnitureimg2 from "../../../Assets/images/f2.png"

import furnitureimg3 from "../../../Assets/images/furniture/f-3-image.png"



import { useNavigate } from "react-router-dom";

import fmobile from "../../../Assets/images/f-mobile.png"


const Furniture = () => {
    const images = [necklace1, necklace2, necklace3];
        const navigate = useNavigate();
  
      const contactus = () => {
          navigate("/contact-us")
      }
    return (
        <>
            <div className="about-hero-section furniture-banner"> 
                <Header />
                <div className="common-width-home-main-container">
                    <div className="about-banner1-main-section">
                        <div>
                            <h1>Crafted to Dazzle, Built to Last</h1>
                            <p>999 silver furniture that blends grandeur, comfort, and timeless artistry — from dining sets to statement sofas.</p>
                            <button className="contact-button" onClick={contactus}>Contact Us</button>
                        </div>
                        {/* <img src={bannerSubimg} alt="banner1" /> */}
                        <img className="furniture-image" src={bannerSubimg} alt="banner"/>
                        <img src={fmobile} alt = "banner-m" className="m-banner-img"/>
                    </div>
                </div>

                <div className="furniture-section">
                    <div className="f-wrapper-1">
                        <h1>Royal Elegance in Every Curve</h1>
                        <p>
                            Transform your living space into a palace with our exquisitely designed silver furniture.
                        </p>
                        <img src={furnitureimg1} alt="img1" />
                        {/* <div className="f1-wrapper-bg">
                            <div className="f1-wrap-contanet">
                                <h1>Crafted for Royalty – Handcrafted Silver Sofa</h1>
                                <p>Meticulously carved in 999 silver and adorned with luxurious upholstery, this timeless piece embodies regal charm and artisanal excellence.</p>
                            </div>
                            <img src={f1img1} alt="logo-wrap-1" />
                        </div> */}
                    </div>

                    <div className="f-wrapper-1">
                        <h1>Timeless Royalty – 999 Silver Designer Chair</h1>
                        <p>
                            Intricately handcrafted in 999 silver, this regal chair blends royal elegance with luxurious comfort."
                        </p>
                        {/* <div className="f2-wrap-container">
                            <div className="f2-wrap-content">
                                <h1>Majesty in Every Curve – 999 Silver Royal Chair</h1>
                                <p>Adorned with detailed carvings and crafted from 999 pure silver, this royal chair is a symbol of timeless elegance and grandeur.</p>
                            </div>
                            <img src={f2img2} alt="logo-wrao-2" />
                        </div> */}
                        <img src={furnitureimg2} alt="img2" />
                    </div>


                    <div className="f-wrapper-1 ">
                        <h1>Royal Beginnings – 999 Silver Baby Cradle</h1>
                        <p>
                            Gracefully designed with intricate silver detailing and elegant black finish, this handcrafted uyala blends tradition with timeless luxury — made for your little one’s majestic dreams.
                        </p>

                        <img src={furnitureimg3} alt="img3" />

                        {/* <div class="uyala-banner">
                            <img src={f3img3} alt="Silver Baby Uyala" />
                            <div class="uyala-text">
                                <h2>Born to Shine</h2>
                                <p>
                                    This handcrafted silver baby uyala is a celebration of new life—
                                    elevating every moment with luxurious detail and royal charm.
                                </p>
                            </div>
                        </div> */}


                    </div>

                </div>

            </div>


        </>
    );
};

export default Furniture;
